import Vue from 'vue';
import VueSession from 'vue-session';

Vue.use(VueSession, {persist: true});

export default VueSession;
